<template>
  <div>
    <b-button @click="newUser()">Ajouter un membre</b-button>
    <b-button class="ml-1" @click="dlAdherents(users)">Listing adherents</b-button>
    <b-table striped hover :items="users" :fields="fields"
      @row-clicked="updateUser">
      <template slot="enabled" slot-scope="data">
        {{ data.item.enabled === 1 ? "Actif" : "Inactif"}}
      </template>
      <template slot="role" slot-scope="data">
        {{ data.item.role === "user" ? "Utilisateur" : "Admin"}}
      </template>
    </b-table>
    
    <b-modal v-model="show" id="userModal" title="Créer/modifier un membre">
      <b-form @submit="onSubmit" >
        <b-form-group
          label="Email :"
          label-for="email">
          <b-form-input disabled v-if="!creationMode"
            id="email"
            type="email"
            v-model="user.email"/>
          <b-form-input v-if="creationMode"
            id="email"
            type="text"
            v-model="user.email"/>
        </b-form-group>
        
        <b-form-group
          label="Nom :"
          label-for="nom">
          <b-form-input
            id="nom"
            type="text"
            v-model="user.name"/>
        </b-form-group>
        
        <b-form-group
          label="prenom :"
          label-for="prenom">
          <b-form-input
            id="prenom"
            type="text"
            v-model="user.surname"/>
        </b-form-group>
        
        <b-form-group
          label="role :"
          label-for="role">
            
          <b-form-select 
            id="role"
            type="text"
            v-model="user.role" :options="roles"></b-form-select>
        </b-form-group>
        
        <b-form-group
          label="Compte :"
          label-for="actif">
            
          <b-form-select 
            id="actif"
            type="text"
            v-model="user.enabled" :options="activations"></b-form-select>
        </b-form-group>
        
        <b-form-group
          label="Adhésion :"
          label-for="anneeadh">
           <!-- dentifiant "adhesion" est filtré par uBlock-->
          <b-form-select 
            id="anneeadh"
            type="text"
            v-model="user.adhesion" :options="adhesions"></b-form-select>
        </b-form-group>
        
        <b-button class="login-submit" type="submit" variant="primary">Créer/modifier</b-button>
        <b-button class="login-submit" type="button" v-if="!creationMode" variant="error" @click="deleteUser">Supprimer</b-button>
      </b-form>
      <div slot="modal-footer">
      </div>
    </b-modal>
    
    <b-modal v-model="okModal" title="Sauvegardé" ok-only>
      <div>
        Utilisateur sauvegardé
      </div>
    </b-modal>
    <b-modal v-model="okDeleteModal" title="Supprimé" ok-only>
      <div>
        Utilisateur supprimé
      </div>
    </b-modal>
    <b-modal v-model="errorModal" title="Oups !!!" ok-only>
      <div>
        Une erreur est survenue
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'

function formatStrAdhesion(year){
  return year+'-'+(year+1);
}

export default {
  name: 'AdminUser',
  data: function(){
    const adhesions = [{value: '', text:'non-adhérent'}];
    for(let i = 2019; i<= Number(new Date().getFullYear()); i++){
      const str = formatStrAdhesion(i);
      adhesions.unshift({value: str, text: str });
    }

    return {
      users: [],
      user: {},
      show: false,
      creationMode: false,
      okModal: false,
      errorModal: false,
      okDeleteModal: false,
      fields: [
        { key: 'email', label: 'Email' },
        { key: 'name', label: 'Nom' },
        { key: 'surname', label: 'Prénom' },
        { key: 'role', label: 'Rôle' },
        { key: 'enabled', label: 'Compte' },
        { key: 'adhesion', label: 'Adhésion' },
      ],
      roles:[
        {value:'user', text:'Utilisateur'},
        {value:'admin', text:'Admin'},
      ],
      activations:[
        {value: 1, text:'Actif'},
        {value: 0, text:'Inactif'},
      ],
      adhesions,
    }
  },
  created: function(){
    this.reloadList();
  },
  methods: {
    newUser() {
      this.creationMode = true
      this.user = {
        enabled: 1,
        role: "user",
      }
      this.show = true
    },
    updateUser(user){
      this.creationMode = false
      this.user = user
      this.show = true
    },
    deleteUser(){
      Vue.$backend.deleteUser(this.user.email).then(() => {
        this.show = false
        this.okDeleteModal = true
        this.reloadList()
      }, () => {
        this.errorModal = true
      })    
    },
    reloadList() {
      Vue.$backend.listUsers().then(res => this.users = res)
    },
    onSubmit(evt) {
      evt.preventDefault()
      
      const user = {
        "email": this.user.email,
        "name": this.user.name,
        "surname": this.user.surname,
        "role": this.user.role,
        "enabled": this.user.enabled,
        "adhesion": this.user.adhesion,
      };
      
      if(this.creationMode){
        Vue.$backend.createUser(user).then(() => {
          this.show = false
          this.okModal = true
          this.reloadList()
        }, () => {
          this.errorModal = true
        })
      } else {
        Vue.$backend.updateUser(user).then(() => {
          this.show = false
          this.okModal = true
          this.reloadList()
        }, () => {
          this.errorModal = true
        })
      }
       
    },
    dlAdherents(users){
      const currDate = new Date();
      users = users.sort((u1, u2) => u1.nom.localeCompare(u2.nom))
      let dateReference = formatStrAdhesion(currDate.getFullYear());
      if(currDate.getMonth() < 8 /* septembre */){
        // adhesion de septembre passé
        dateReference = formatStrAdhesion(currDate.getFullYear()-1);
      }

      let csv = ['Nom,Prénom,Email'];
      for(const user of users){
        if(user.adhesion === dateReference){
          csv.push(`${user.nom},${user.prenom},${user.email}`);
        }
      }

      Vue.$custom.dlCsv(csv.join('\n'), `Adhérents_${dateReference}.csv`);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
